import { ActionTypes } from '../constants/index';
import { freeze } from '../modules/freeze';


export function getVariantInfo(variantUrlsafe:string): Object {
  return {
    type: ActionTypes.EDITOR_GET_REQUEST,
    payload: { variantUrlsafe },
  };
}

export function addBlock(variantUrlsafe:string, insertIndex:number, name:string, content:Object): Object {
  const tempBlockUrlsafe = `temp-${Date.now().toString()}-${insertIndex}`;
  return {
    type: ActionTypes.EDITOR_BLOCK_ADD_REQUEST,
    payload: {
      variantUrlsafe,
      insertIndex,
      name,
      content,
      tempBlockUrlsafe,
    },
  };
}

export function addBlocks(variantUrlsafe:string, insertIndex:number, blocks:Array): Object {
  const updatedBlocks = blocks.map((block, index) => {
    block.tempBlockUrlsafe = `temp-${Date.now().toString()}-${insertIndex + index}`;
    block.content = freeze(block.jsx);
    return block;
  });
  return {
    type: ActionTypes.EDITOR_BLOCKS_ADD_REQUEST,
    payload: {
      variantUrlsafe,
      insertIndex,
      blocks: updatedBlocks,
    },
  };
}

export function renameBlock(variantUrlsafe: string, blockUrlsafe:string, name:string): Object {
  return {
    type: ActionTypes.EDITOR_BLOCK_RENAME_REQUEST,
    payload: { variantUrlsafe, blockUrlsafe, name },
  };
}

export function deleteBlock(variantUrlsafe:string, blockUrlsafe:string): Object {
  return {
    type: ActionTypes.EDITOR_BLOCK_DELETE_REQUEST,
    payload: { variantUrlsafe, blockUrlsafe },
  };
}

export function deleteElement(variantUrlsafe:string, blockUrlsafe:string, address:Array): Object {
  return {
    type: ActionTypes.EDITOR_ELEMENT_DELETE_REQUEST,
    payload: { variantUrlsafe, blockUrlsafe, address },
  };
}

export function reorderBlock(variantUrlsafe:string, previousIndex:number, nextIndex:number): Object {
  return {
    type: ActionTypes.EDITOR_BLOCK_REORDER_REQUEST,
    payload: { variantUrlsafe, previousIndex, nextIndex },
  };
}

export function updateBlock(
  variantUrlsafe:string,
  blockUrlsafe:string,
  address:Array,
  updatedProps:Object
): Object {
  return {
    type: ActionTypes.EDITOR_BLOCK_UPDATE_REQUEST,
    payload: { variantUrlsafe, blockUrlsafe, address, updatedProps },
  };
}

export function syncBlock(
  variantUrlsafe: string,
  blockUrlsafe: string,
  content: Object,
  synctill: number
): Object {
  return {
    type: ActionTypes.EDITOR_BLOCK_SYNC_REQUEST,
    payload: { variantUrlsafe, blockUrlsafe, content, synctill },
  };
}

export function updateColor(variantUrlsafe:string, color:Object): Object {
  return {
    type: ActionTypes.EDITOR_COLOR_UPDATE_REQUEST,
    payload: { variantUrlsafe, color },
  };
}

export function updateFont(variantUrlsafe:string, font:Object): Object {
  return {
    type: ActionTypes.EDITOR_FONT_UPDATE_REQUEST,
    payload: { variantUrlsafe, font },
  };
}

export function updateSeo(variantUrlsafe:string, key:string, value:Object): Object {
  return {
    type: ActionTypes.EDITOR_SEO_UPDATE_REQUEST,
    payload: { variantUrlsafe, key, value },
  };
}

export function updateAnalytics(variantUrlsafe:string, key:string, val:string): Object {
  return {
    type: ActionTypes.EDITOR_GID_UPDATE_REQUEST,
    payload: {
      variantUrlsafe,
      key,
      value: val,
    },
  };
}

export function publish(variantUrlsafe:string, publishData:string): Object {
  return {
    type: ActionTypes.EDITOR_PUBLISH_REQUEST,
    payload: {
      variantUrlsafe,
      publish: publishData,
    },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/editor.js